import classNames from 'classnames';
import { useDonorSearch } from 'hooks/useDonors';
import Avatar from 'components/common/Avatar';
import Logo from 'components/common/Logo';
import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
import AppContext from 'context/Context';
import { useAuthContext } from 'context/authContext';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
// import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import SearchBox from './SearchBox';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import BranchDropdown from './BranchDropdown';

const NavbarTop = () => {
  const {
    config: { showBurgerMenu, navbarPosition, navbarCollapsed },
    setConfig
  } = useContext(AppContext);
  const { pathname } = useLocation();
  const isChat = pathname.includes('chat');
  const { organization } = useAuthContext();
  const [showDropShadow, setShowDropShadow] = useState(false);

  // Server-side global search: query the DB for matches as the user types
  // (>= 3 chars) instead of pre-loading every donor into the browser. This is
  // what makes the whole app start faster and keeps search scaling.
  const [searchTerm, setSearchTerm] = useState('');
  const { donors } = useDonorSearch({
    search: searchTerm,
    page: 0,
    pageSize: 20,
    enabled: searchTerm.trim().length >= 3
  });

  const searchData = useMemo(() => {
    if (!donors || donors.length === 0) return [];

    return donors.map(item => {
      const email = item.primary_email || '';
      const phone = item.primary_phone || '';
      const addressText = item.primary_address || '';
      const displayText = [email, phone, addressText]
        .filter(Boolean)
        .join(' - ');

      return {
        id: item.id,
        url: '/donors/' + item.id + '/profile',
        catagories: 'suggestionMembers',
        icon: {
          img: (
            <Avatar
              src={''}
              rounded="circle"
              size="xl"
              name={item.first_name + ' ' + item.last_name}
            />
          ),
          size: 'l'
        },
        simple_id: item.simple_id,
        organisation_name: organization.organisation_name,
        title: item.first_name + ' ' + item.last_name,
        text: displayText,
        address: addressText
      };
    });
  }, [donors, organization]);
  const handleBurgerMenu = () => {
    (navbarPosition === 'top' || navbarPosition === 'double-top') &&
      setConfig('navbarCollapsed', !navbarCollapsed);
    (navbarPosition === 'vertical' || navbarPosition === 'combo') &&
      setConfig('showBurgerMenu', !showBurgerMenu);
  };

  const setDropShadow = () => {
    const el = document.documentElement;
    if (el.scrollTop > 0) {
      setShowDropShadow(true);
    } else {
      setShowDropShadow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setDropShadow);
    return () => window.removeEventListener('scroll', setDropShadow);
  }, []);

  const burgerMenuRef = useRef();

  return (
    <>
      <Navbar
        className={classNames(
          'navbar-glass fs--1 navbar-top sticky-kit flex-wrap',
          {
            // 'navbar-glass-shadow': showDropShadow
            'navbar-glass-shadow': showDropShadow && !isChat
          }
        )}
        expand={
          navbarPosition === 'top' ||
          navbarPosition === 'combo' ||
          navbarPosition === 'double-top'
            ? topNavbarBreakpoint
            : true
        }
      >
        <NavbarTopElements
          navbarCollapsed={navbarCollapsed}
          navbarPosition={navbarPosition}
          handleBurgerMenu={handleBurgerMenu}
          burgerMenuRef={burgerMenuRef}
          searchData={searchData}
          onSearchChange={setSearchTerm}
        />
      </Navbar>
      {/* {type !== 'organization' ? (
        isMediumScreen && <NavbarTopDropDownMenus width={width} />
      ) : (
        <></>
      )} */}
    </>
  );
};

export const NavbarTopElements = ({
  navbarPosition,
  handleBurgerMenu,
  searchData,
  onSearchChange
}) => {
  const burgerMenuRef = useRef();
  return (
    <>
      <Navbar.Toggle
        ref={burgerMenuRef}
        className={classNames('toggle-icon-wrapper me-md-3 me-2', {
          'd-lg-none':
            navbarPosition === 'top' || navbarPosition === 'double-top',
          [`d-${navbarBreakPoint}-none`]:
            navbarPosition === 'vertical' || navbarPosition === 'combo'
        })}
        as="div"
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </Navbar.Toggle>

      <Logo
        at="navbar-top"
        width={40}
        id="topLogo"
        textClass="d-none d-sm-block"
      />

      <BranchDropdown />

      <Nav navbar className="d-flex order-last order-lg-0 w-100 w-lg-auto mt-2 mt-lg-0" as="ul">
        <Nav.Item as="li" className="w-100">
          <SearchBox
            autoCompleteItem={searchData}
            onSearchChange={onSearchChange}
          />
        </Nav.Item>
      </Nav>

      <div className="ms-auto">
        <TopNavRightSideNavItem />
      </div>
    </>
  );
};

NavbarTopElements.propTypes = {
  navbarPosition: PropTypes.string,
  handleBurgerMenu: PropTypes.func,
  navbarCollapsed: PropTypes.bool,
  searchData: PropTypes.array,
  onSearchChange: PropTypes.func
};

NavbarTop.propTypes = {
  type: PropTypes.string,
  isMediumScreen: PropTypes.boolean,
  width: PropTypes.number
};
export default NavbarTop;
